import { Component, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { SQLService } from '../../../services/sql.service';
import { backgrounds, backgrounds_lowrez } from '../../../../environments/logos';
@Component({
  selector: 'app-cashiers-cheque',
  templateUrl: './cashiers-cheque.component.html',
  styleUrls: ['./cashiers-cheque.component.scss'],
})
export class CashiersChequeComponent implements AfterViewInit {
  constructor(private sql: SQLService) { }
  @Output('loaded') loaded = new EventEmitter<boolean>();
  @Input('RenderMICR') RenderMICR = false;
  @Input('ImageMICR') ImageMICR = true;
  @Input('show') show = 'table';
  @Input('cheque') cheque: any;
  @Input('design') design: any;
  @Input('designer') designer: any;
  @Input('rotate') rotate: boolean;
  @Input('borders') borders: boolean;
  @Input('voidcheck') voidcheck: boolean;
  @Input('font') font: any;
  @Input('fiat') fiat: boolean;
  @Input('color') color: any;
  @Input('micr') micr: any;
  micr_top=false;
  micr_right=false;
  micr_bottom='3mm';
  micr_left='9mm';
  @Input('secret') secret = '';
  @Input('scale') scale =1;
  @Input('fold_line') fold_line: boolean;
  @Input('template') template: string;
  @Input('monochrome') monochrome: boolean;
  @Input('gradients') gradients: boolean;
  @Input('margin_bottom') bottom = '0mm';
  @Input('margin_top') top = '0mm';
  @Input('fontsize') fontsize: boolean;
  @Input('layers') layers: any;
  @Input('translations') translations = this.sql.word;
  @Input('bold') bold: boolean;
  @Input('italic') italic: boolean;
  @Input('show_cheque_number') show_cheque_number: boolean = true;
  @Input('show_cheque_date') show_cheque_date: boolean = true;
  @Input('show_micr') show_micr: boolean = true;
  @Input('cheque_background_image_repeat') cheque_background_image_repeat = false;
  @Input('background_position') background_position: string;
  @Input('cheque_text_color') cheque_text_color: string;
  @Input('cheque_background_image') cheque_background_image: any;
  @Input('cheque_logo_image') cheque_logo_image: any;
  @Input('cheque_header_image') cheque_header_image: any;
  @Input('cheque_bank_image') cheque_bank_image: any;
  @Input('doc_color') doc_color: string = 'blue';
  bg_image: string;
  loaded_component() {this.loaded.emit(true);}
  ngAfterViewInit() {
    this.design["height"]='69mm';
    this.design["date"]["top"]='22mm';
    this.design["date"]["right"]='27mm';
    this.design["date"]["alternative_2"]=true;
    this.design["date_label"]["display"]=false;
    this.design["payline"]["prefix"]=false;
    this.design["payline"]["borders"]=false;
    this.design["payline"]["top"]='23.5mm';
    this.design["payline"]["right"]='27px';
    this.design["payline"]["bottom"]='4px';
    this.design["payline"]["left"]='26.5mm';
    this.design["printed_id"]["top"]='27.3px';
    this.design["printed_id"]["right"]='45px';
    this.design["payment_name"]["bottom"]="1px";
    this.design["payment_name"]["left"]="35px";
    this.design["written_amount"]["top"]='36.7mm';
    this.design["written_amount"]["right"]=false;
    this.design["written_amount"]["bottom"]='30mm';
    this.design["written_amount"]["left"]='16.2mm';
    this.design["written_amount_line"]["width"]='550px';
    this.design["written_amount"]["index"]=false;
    this.design["written_amount_line"]["borders"]=false;
    this.design["written_amount_line"]["overflow"]=true;
    this.design["written_amount_line"]["top"]='0px';
    this.design["written_amount_line"]["right"]='0px';
    this.design["written_amount_line"]["bottom"]='0px';
    this.design["written_amount_line"]["left"]='0px';
    this.design["multiline_written_amount_chars"]=57;
    this.design["written_amount_line2"]["top"]='4.5mm'
    this.design["written_amount_line2"]["right"]='0mm'
    this.design["written_amount_line2"]["bottom"]='0mm'
    this.design["written_amount_line2"]["left"]='0mm'
    this.design["amounts"]["symbol"]=false;
    this.design["amount_number"]["borders"]=false;
    this.design["amount_number"]["background"]=false;
    this.design["amount_number"]["top"]="2.9mm";
    this.design["amount_number"]["right"]="auto";
    this.design["amount_number"]["bottom"]="auto";
    this.design["amount_number"]["left"]="2.1mm";
    this.design["memo"]["label"]=true;
    this.design["memo"]["border"]=false;
    this.design["memo"]["lineheight"]='12px';
    this.design["memo"]["bottom"]='11.4mm';
    this.design["memo"]["left"]='18.2mm';
    this.design["memo"]["right"]='auto';
    this.design["memo"]["width"]='76mm';
    this.design["public_image"]["top"]='31.5mm';
    this.design["public_image"]["right"]='14.3mm';
    this.design["public_image"]["width"]='67';
    this.design["public_image"]["zindex"]='1';
    this.design['public_image']['QRcolorDark']="#13699c";
    this.design['public_image']['QRcolorLight']="#f0efee";
    this.design['public_image']['QRCodeMargin']="1";
    this.design["key_image"]["width"]='77';
    this.design["key_image"]["left"]='13.5mm';
    this.design["key_image"]["top"]='15.7mm';
    this.design["key_image"]["zindex"]='1';
    this.design['key_image']['QRcolorDark']="#13699c";
    this.design['key_image']['QRcolorLight']="#f0efee";
    this.design['key_image']['QRCodeMargin']="1";
    this.design["currency_name"]["top"]='23.4mm'; 
    this.design["currency_name"]["left"]='auto';
    this.design["currency_name"]["right"]='16.1mm';
    this.design["address_data"]["top"]='15mm';
    this.design["address_data"]["left"]='37.2mm';
    this.design["address_data"]["width"]='53.5mm !important';
    this.design["signature"]["container_width"]='44mm';
    this.design["signature"]["width"]='180px';
    this.design["signature"]["border"]=false;
    this.design["signature"]["label"]=false;
    this.design["signature"]["right"]='auto';
    this.design["signature"]["bottom"]='20.5mm';
    this.design["signature"]["left"]='99.5mm';
    this.design["signature"]["info"]["top"]="9mm";
    this.design["signature"]["desc"]["top"]="9mm";
    this.design["micr"]["top"]='auto';
    this.design["micr"]["right"]='auto';
    this.design["micr"]["bottom"]='3mm';
    this.design["micr"]["left"]='9mm';
    this.design["micr"]["background"]=true;
    if(this.sql.model=='web') {
      var img = "cashierscheque";
      this.sql.load_background(img,(base64Img)=>{
        this.bg_image=base64Img;
      },this.sql.production);
    } else {
      this.bg_image = this.sql.production?backgrounds.cashierscheque:backgrounds_lowrez.cashierscheque;
    }
}
}